export interface LoginResult {
  authToken?: string;
}

export const loginResultFromResponse = (responseData: any): LoginResult => ({
  authToken: responseData.auth_token,
});
